import PropTypes from "prop-types";
import styles from "./SnackBarWithDismiss.module.scss";
import config from "../../../config/index";

const SnackBarWithDismiss = props => {
  const env = config.env;
	const imagePrefix = config.envConfigs[env].imagePrefix;
  return (
    <div
      className={props.isVisible ? `${styles.snackBar} ${props.className}` : ""}
    >
      <div className={styles.snackBar__msgContainer}>
        <label className={styles.snackBar__label}>{props.message}</label>
      </div>
      <div className={styles.snackBar__dismissContainer}>
        <span
            onClick={props.closeSnackBar}
            className={styles["dismissLink"]}
          >
            Dismiss
        </span>
      </div>
    </div>
  );
};

SnackBarWithDismiss.propTypes = {
  message: PropTypes.string,
  style: PropTypes.object,
  closeSnackBar: PropTypes.func,
  isVisible: PropTypes.bool,
  className: PropTypes.string
};

export default SnackBarWithDismiss;
